var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4111 2.22222L17.7778 7.58889V17.7778H2.22222V2.22222H12.4111ZM12.4111 0H2.22222C1 0 0 1 0 2.22222V17.7778C0 19 1 20 2.22222 20H17.7778C19 20 20 19 20 17.7778V7.58889C20 7 19.7667 6.43333 19.3444 6.02222L13.9778 0.655555C13.5667 0.233333 13 0 12.4111 0ZM4.44444 13.3333H15.5556V15.5556H4.44444V13.3333ZM4.44444 8.88889H15.5556V11.1111H4.44444V8.88889ZM4.44444 4.44444H12.2222V6.66667H4.44444V4.44444Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.686ddc22aa2ec1e77cdadf58d81e3a20.svg";
export { ForwardRef as ReactComponent };